import { useTranslation } from "react-i18next";
import { Row, Col, Button } from "react-bootstrap";
import ContentPillarTimeline from "./Subcomponents/ContentPillarTimeline";
import crudApi from "@serie3/common/api/crudApi";
import { useState, useEffect } from "react";
import SocialEndpoints from "@serie3/mymediaplanner/Modules/Social/endpoints";
import NewModal from "../../../shared/Modals/NewModal";
import ContentPillarFormView from "./Subcomponents/ContentPillarFormView";
import { useFormik } from "formik";
import ContentPillarForm from "@serie3/mymediaplanner/Modules/Social/Forms/ContentPillarForm";
import ContentPillar from "@serie3/mymediaplanner/Modules/Social/Entity/ContentPillar";
import PostFormView from "../PostFormView";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLayerGroup } from "@fortawesome/free-solid-svg-icons";

const ContentPillars = ({ props }) => {
  const { t } = useTranslation();

  const [pillars, setPillars] = useState([]);
  const [loading, setLoading] = useState(true);
  const [show, setShow] = useState(false);
  const [editPillar, setEditPillar] = useState([]);
  const [posts, setPosts] = useState([]);
  const [showPostForm, setShowPostForm] = useState(false);
  const [editPost, setEditPost] = useState(null);
  const [trigger, setTrigger] = useState(-1);
  const [pillarStats, setPillarStats] = useState({});

  const onStatsUpdate = (id, s) =>
    setPillarStats((prev) => ({ ...prev, [id]: s }));

  const badges = (() => {
    const ids = Object.keys(pillarStats);
    if (ids.length < 2) return {};
    const scores = ids.map((id) => ({ id, score: pillarStats[id].totalScore ?? 0 }));
    const maxScore = Math.max(...scores.map((s) => s.score));
    const minScore = Math.min(...scores.map((s) => s.score));
    const result = {};
    scores.forEach(({ id, score }) => {
      result[id] = {
        isBest:  score === maxScore && maxScore > 0,
        isWorst: score === minScore && minScore < maxScore,
      };
    });
    return result;
  })();

  const pillarForm = ContentPillarForm.createContentPillarForm(
    pillars,
    setPillars
  );
  const formik = useFormik(pillarForm);

  useEffect(() => {
    const fetchPillars = async () => {
      await crudApi.getAll(
        SocialEndpoints.posts.contentPillars.index,
        setPillars,
        "contentpillars"
      );
      setLoading(false);
    };
    fetchPillars();
  }, []);

  const AddBtn = () => (
    <button
      type="button"
      onClick={() => setShow(true)}
      style={{
        display: "inline-flex", alignItems: "center", gap: 6,
        padding: "8px 18px", borderRadius: 8, border: "none", cursor: "pointer",
        background: "#51d28c", color: "#fff",
        fontFamily: "Montserrat, sans-serif", fontWeight: 600, fontSize: 14,
        transition: "background 0.15s ease",
      }}
      onMouseEnter={(e) => { e.currentTarget.style.background = "#3bbf78"; }}
      onMouseLeave={(e) => { e.currentTarget.style.background = "#51d28c"; }}
    >
      <FontAwesomeIcon icon={faLayerGroup} style={{ fontSize: 11 }} />
      {t("Backend.Post.ContentPillars.New")}
    </button>
  );

  const editAction = (pillar) => {
    setEditPillar(pillar);
    setShow(true);
  };

  return (
    <>
      <NewModal
        title={t("Backend.Post.ContentPillars.Modal.Title")}
        show={show}
        setShow={setShow}
        onShow={() => {
          editPillar
            ? formik.setValues(ContentPillarForm.setEditData(editPillar))
            : formik.setValues(ContentPillar);
        }}
        onExit={() => {
          formik.resetForm();
        }}
        ExtraButton={() => {
          return (
            <Button onClick={() => formik.submitForm()}>
              {t("Backend.Buttons.Save")}
            </Button>
          );
        }}
      >
        <ContentPillarFormView formik={formik} />
      </NewModal>

      <PostFormView
        showEdit={showPostForm}
        setShowEdit={setShowPostForm}
        editData={editPost}
        dataList={posts}
        setDataList={setPosts}
        trigger={trigger}
        setTrigger={setTrigger}
        refreshOnClose={true}
      />
      <div className="d-flex align-items-center justify-content-between mb-4">
        <h4 className="page-section-header" style={{ marginBottom: 0 }}>
          <span className="page-section-header-icon" style={{ background: "rgba(86,74,177,0.12)" }}>
            <FontAwesomeIcon icon={faLayerGroup} style={{ color: "#564ab1" }} />
          </span>
          {t("Backend.Post.ContentPillars.Title")}
        </h4>
        <AddBtn />
      </div>

      {loading ? (
        [1, 2, 3].map((i) => (
          <div key={i} className="row mb-4">
            <div className="col-lg-12">
              <div className="card" style={{ borderLeft: "4px solid #e2e5ea", borderRadius: 16 }}>
                <div className="card-body" style={{ padding: "20px 24px" }}>
                  <div className="d-flex align-items-center mb-3" style={{ gap: 10 }}>
                    <div className="skeleton" style={{ width: 10, height: 10, borderRadius: "50%" }} />
                    <div className="skeleton" style={{ width: 160, height: 16 }} />
                    <div className="skeleton" style={{ width: 60, height: 14, marginLeft: "auto" }} />
                  </div>
                  <div className="d-flex gap-3">
                    {[1, 2, 3].map((j) => (
                      <div key={j} className="skeleton" style={{ flex: 1, height: 140, borderRadius: 12 }} />
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))
      ) : pillars.map((pillar, index) => {
        return (
          <ContentPillarTimeline
            pillar={pillar}
            key={pillar.id}
            index={index}
            pillars={pillars}
            setPillars={setPillars}
            editAction={editAction}
            setEditPostList={setPosts}
            setEditPost={setEditPost}
            setShowPostForm={setShowPostForm}
            trigger={trigger}
            onStatsUpdate={onStatsUpdate}
            badges={badges[pillar.id] ?? {}}
          />
        );
      })}
    </>
  );
};

export default ContentPillars;
